import loadable from '@loadable/component';

export const PetsradarSiteWrapper = loadable(
  () => import(/* webpackChunkName: "petsradar-site" */ './PetsradarSiteWrapper'),
);
